import React from 'react';
import {
	useSelector,
} from 'react-redux';

import PagesOverviewPage from '~/components/views/authenticated/PagesOverviewPage';

import {
	contentCurrentSelector,
} from '~/state/ui/content/selectors';

import useWindowHasFocus from '~/hooks/useWindowHasFocus';



/**
 * Determines if the PagesOverviewPage is currently visible and active.
 * Returns true only when:
 * - PagesOverviewPage is the current active component
 * - Window has focus
 */
function useIsPagesOverviewVisible(): boolean {
	const current = useSelector(contentCurrentSelector);
	const windowHasFocus = useWindowHasFocus();

	return React.useMemo(
		() => current === PagesOverviewPage && windowHasFocus,
		[
			current,
			windowHasFocus,
		],
	);
}



export default useIsPagesOverviewVisible;
